import AudiobookSlide from "../../react_components/carousel/slides/audiobook_slide";
import AudiobookTooltip from "../../react_components/carousel/slides/audiobook_tooltip";
import AudiobookMobileSlide from "../../react_components/carousel/slides/audiobook_mobile_slide";
import MarketingSlide from "../../react_components/carousel/slides/marketing_slide";
import SampleSlide from "../../react_components/carousel/slides/sample_slide";

export const objectTypeToComponentMap = {
  audiobookSlide: AudiobookSlide,
  audiobookTooltip: AudiobookTooltip,
  audiobookMobileSlide: AudiobookMobileSlide,
  marketingSlide: MarketingSlide,
  sample: SampleSlide,
};

export const nextTransitionMessage = "next";
export const previousTransitionMessage = "prev";

export const getStoreObjects = function(props) {
  const slideArray = [];
  const tooltipArray = [];
  const slideType = props.slideType;
  const slides = props.slides;
  const tooltipType = props.tooltipType;
  const tooltips = props.tooltips;
  const ReactSlideComponentType = getReactObjectByType(slideType);
  if (ReactSlideComponentType) {
    slides.forEach((entry) => {
      const slideObj = (<ReactSlideComponentType {...entry}/>);
      slideArray.push(slideObj);
    });
  } else {
    slides.forEach(() => {
      const slideObj = (<div>Sorry. Could not resolve the carouselSlideType property to a valid React Component. Please review the property value</div>);
      slideArray.push(slideObj);
    });
  }
  if (tooltipType) {
    const ReactTooltipComponentType = getReactObjectByType(tooltipType);
    if (ReactTooltipComponentType) {
      tooltips.forEach((entry) => {
        const tooltipObj = (<ReactTooltipComponentType {...entry}/>);
        tooltipArray.push(tooltipObj);
      });
    }
  }
  const returnObj = { slides: slideArray };
  if (tooltipArray.length > 0) {
    returnObj.tooltips = tooltipArray;
  }
  return returnObj;
};

export const getReactObjectByType = function(type) {
  return objectTypeToComponentMap[type];
};

export const computeTrackStyle = function(spec) {
  const trackLeft = computeTrackLeftOffset(spec);

  let trackWidth;
  if (spec.carouselWrapAround) {
    trackWidth = (spec.carouselSlidesToShow * spec.slideContainerWidth) + (2 * spec.carouselSlidesToScroll * spec.slideContainerWidth);
  }
  else {
    let numberOfSlidesToLoad = 0;
    let slideIndex;
    if (spec.animating) {
      slideIndex = spec.currentSlide;
    } else {
      slideIndex = spec.hasOwnProperty("targetSlide") ? spec.targetSlide : spec.currentSlide;
    }
    numberOfSlidesToLoad += slideIndex + spec.carouselSlidesToShow;
    if (slideIndex + spec.carouselSlidesToShow + spec.carouselSlidesToScroll < spec.slideCount) {
      numberOfSlidesToLoad += spec.carouselSlidesToScroll;
    } else {
      numberOfSlidesToLoad += (spec.slideCount - slideIndex - spec.carouselSlidesToShow);
    }
    trackWidth = numberOfSlidesToLoad * spec.slideContainerWidth;
  }

  const style = {
    opacity: 1,
    width: trackWidth,
    WebkitTransform: `translate3d(${  trackLeft  }px, 0px, 0px)`,
    transform: `translate3d(${  trackLeft  }px, 0px, 0px)`,
    transition: "",
    WebkitTransition: "",
    msTransform: `translateX(${  trackLeft  }px)`,
  };

  // Fallback for IE8 - found this snippet online about a potential issue with IE8. have to test this.
  if (!window.addEventListener && window.attachEvent) {
    style.marginLeft = `${trackLeft  }px`;
  }

  return style;
};

export const computeTrackLeftOffset = function (spec) {
  let trackLeftOffset;
  const targetSlide = spec.hasOwnProperty("targetSlide") ? spec.targetSlide : spec.currentSlide;
  if (spec.carouselWrapAround) {
    trackLeftOffset =  spec.slideContainerWidth * spec.carouselSlidesToScroll * -1;
    if (spec.animating) {
      if (targetSlide > spec.currentSlide) {
        trackLeftOffset -= spec.slideContainerWidth * spec.carouselSlidesToScroll;
      } else if (targetSlide < spec.currentSlide) {
        trackLeftOffset +=  spec.slideContainerWidth * spec.carouselSlidesToScroll;
      }
    }
  }
  else {
    trackLeftOffset = ((targetSlide * spec.slideContainerWidth) * -1);
  }
  return trackLeftOffset;
};

export const computeTrackAnimationStyle = function (spec) {
  const style = computeTrackStyle(spec);
  style.WebkitTransition = `-webkit-transform ${  spec.carouselSlidingSpeed  }ms ease`;
  style.transition = `transform ${  spec.carouselSlidingSpeed  }ms ease`;
  return style;
};
